export type AppRoute =
  | { view: 'create' }
  | { view: 'billing' }
  | { view: 'outline'; projectId: string }
  | { view: 'read'; projectId: string; sceneIndex?: number };

function decodeSegment(value: string) {
  try {
    return decodeURIComponent(value);
  } catch {
    return null;
  }
}

export function parseRoute(pathname: string): AppRoute {
  const segments = pathname.split('/').filter(Boolean).map(decodeSegment);
  if (segments.some((segment) => segment === null)) return { view: 'create' };
  if (segments.length === 2 && segments[0] === 'account' && segments[1] === 'billing') {
    return { view: 'billing' };
  }
  const [root, projectId, section, rawSceneIndex] = segments as string[];
  if (root !== 'stories' || !projectId) return { view: 'create' };
  if (!section || section === 'outline') return { view: 'outline', projectId };
  if (section !== 'read' || segments.length > 4) return { view: 'create' };
  if (!rawSceneIndex) return { view: 'read', projectId };
  const sceneIndex = Number.parseInt(rawSceneIndex, 10);
  if (!Number.isInteger(sceneIndex) || sceneIndex < 1 || String(sceneIndex) !== rawSceneIndex) {
    return { view: 'create' };
  }
  return { view: 'read', projectId, sceneIndex };
}

export function routePath(route: AppRoute) {
  if (route.view === 'create') return '/';
  if (route.view === 'billing') return '/account/billing';
  const projectPath = `/stories/${encodeURIComponent(route.projectId)}`;
  if (route.view === 'outline') return projectPath;
  return route.sceneIndex === undefined
    ? `${projectPath}/read`
    : `${projectPath}/read/${route.sceneIndex}`;
}

export function routeProjectId(route: AppRoute) {
  return route.view === 'outline' || route.view === 'read'
    ? route.projectId
    : undefined;
}
